import type {ReactElement} from 'react';
import {Icon} from '@Components/icon-v2';
import {IconSize} from '@Components/icon-v2/icon.types';
import {Text, TextSize} from '@Components/text';
import type {MobileBlockItemProps} from './mobile-block-item.types';
import styles from '../../email-maker-block-manager.module.scss';

/** Mobile block-list row (icon bubble + title + description); the caller supplies the interaction layer. */
export function MobileBlockItem({icon, label, description, containerClasses = '', iconContainerClasses = '', textClasses = ''}: MobileBlockItemProps): ReactElement {
  return (
    <div className={`${styles.mobileBlockVisualContainer} ${containerClasses}`}>
      <div className={`${styles.mobileIconContainer} ${iconContainerClasses}`}>
        <div className={styles.mobileIconShadowContainer}>
          <Icon icon={icon} className={styles.mobileIcon} size={IconSize.SIZE_ICON_16} />
        </div>
      </div>

      <div className={styles.mobileBlockTextContainer}>
        <Text val={label} size={TextSize.XSMALL} bold className={textClasses || styles.mobileBlockTitle} />
        <Text val={description} size={TextSize.XXSMALL} className={textClasses || styles.mobileBlockDescription} />
      </div>
    </div>
  );
}
